import { __assign, __generator, __spreadArray } from "tslib";
import { delay, put, fork, take, race, cancel, call, select, } from '@redux-saga/core/effects';
import ddt from '@wix/da-ddt';
import { createAction } from 'redux-actions';
import { isApiError, request } from '../xhr';
import { cancelFetchForStream, fetchFailure, markAsCancelled, markAsFetching, } from './base/actions';
import { getStreamType } from './base/selectors';
import * as offsetActions from './withOffset/actions';
import * as cursorActions from './withCursor/actions';
import { StreamType } from './types';
var logger = ddt.createLogger('streamHelpers');
export function getActionsForStreamType(type) {
    switch (type) {
        case StreamType.WITH_OFFSET:
            return offsetActions;
        case StreamType.WITH_CURSOR:
            return cursorActions;
        default:
            return {};
    }
}
export var createCallbackActionCreator = function (actionType) {
    return createAction(actionType, function (streamId) { return ({ streamId: streamId }); });
};
/** @deprecated use takeStreamFetch */
export function throttleFetchingTask(streamId, throttleMs) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, delay(throttleMs)];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(markAsFetching(streamId))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/** Listens for fetch actions for a stream. If further actions come for the
 * same stream while there is a fetch already in progress, it discards them.
 * Also allows for canceling of any streams it is handling via cancelFetchForStream */
export var takeStreamFetch = function (patternOrChannel, handler) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return fork(function () {
        var forks, _a, fetchAction, cancelAction, streamId, task, streamId, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    forks = {};
                    _d.label = 1;
                case 1:
                    if (!true) return [3 /*break*/, 8];
                    return [4 /*yield*/, race({
                            fetchAction: take(patternOrChannel),
                            cancelAction: take(cancelFetchForStream),
                        })];
                case 2:
                    _a = _d.sent(), fetchAction = _a.fetchAction, cancelAction = _a.cancelAction;
                    if (!cancelAction) return [3 /*break*/, 5];
                    streamId = cancelAction.payload.streamId;
                    task = forks[streamId];
                    if (!task) return [3 /*break*/, 5];
                    return [4 /*yield*/, cancel(task)];
                case 3:
                    _d.sent();
                    return [4 /*yield*/, put(markAsCancelled(streamId))];
                case 4:
                    _d.sent();
                    _d.label = 5;
                case 5:
                    if (!fetchAction) return [3 /*break*/, 7];
                    streamId = fetchAction.payload.streamId;
                    if (forks[streamId] && forks[streamId].isRunning()) {
                        return [2 /*return*/];
                    }
                    _b = forks;
                    _c = streamId;
                    return [4 /*yield*/, fork.apply(void 0, __spreadArray([handler], args.concat(fetchAction), false))];
                case 6:
                    _b[_c] = _d.sent();
                    _d.label = 7;
                case 7: return [3 /*break*/, 1];
                case 8: return [2 /*return*/];
            }
        });
    });
};
function getFetchSuccessActionForDirection(actions, direction) {
    switch (direction) {
        case 'all':
            return actions.fetchAllSuccess;
        case 'prev':
            return actions.fetchPreviousSuccess;
        case 'next':
        default:
            return actions.fetchSuccess;
    }
}
/** Helper to do the fetching stuff right. Use in combination with takeStreamFetch. */
export function fetchStreamContents(_a) {
    var result, streamType, actions, fetchSuccess, e_1;
    var streamId = _a.streamId, url = _a.url, baseURL = _a.baseURL, _b = _a.direction, direction = _b === void 0 ? 'next' : _b, params = _a.params, getStreamData = _a.getStreamData, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 8]);
                logger.log('Fetching stream', streamId, params);
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: url,
                        baseURL: baseURL,
                        params: params,
                        enableCancellation: true,
                    })];
            case 1:
                result = _c.sent();
                if (!(!result || isApiError(result))) return [3 /*break*/, 3];
                logger.error('Error response', streamId, result);
                return [4 /*yield*/, put(fetchFailure({
                        streamId: streamId,
                        errorMsg: result ? result.error : 'Failed to fetch...',
                    }))];
            case 2:
                _c.sent();
                onFailure && onFailure(result);
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getStreamType, streamId)];
            case 4:
                streamType = _c.sent();
                actions = getActionsForStreamType(streamType);
                fetchSuccess = getFetchSuccessActionForDirection(actions, direction);
                if (!fetchSuccess) {
                    return [2 /*return*/];
                }
                logger.log('Successful fetch', streamId, result);
                return [4 /*yield*/, put(fetchSuccess(__assign({ streamId: streamId }, getStreamData(result))))];
            case 5:
                _c.sent();
                onSuccess && onSuccess(result);
                return [3 /*break*/, 8];
            case 6:
                e_1 = _c.sent();
                logger.error('Error caught while fetching', e_1);
                return [4 /*yield*/, put(fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch...',
                    }))];
            case 7:
                _c.sent();
                onFailure && onFailure();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=helpers.js.map